import { render, staticRenderFns } from "./ships-scheduled-route.vue?vue&type=template&id=1d71d3f6&"
import script from "./ships-scheduled-route.vue?vue&type=script&lang=js&"
export * from "./ships-scheduled-route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports